import React, { FC } from 'react';
import { Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { App } from '../../../models/app';
import styles from './styles.module.scss';
import { Variant } from '@material-ui/core/styles/createTypography';

interface ComponentProps {
  app: App,
  actionText: string,
  variant?: Variant
}

export const AppActionDisclaimer: FC<ComponentProps> = ({app, actionText, variant= 'caption'}):JSX.Element => {
  const { t } = useTranslation();
  const { privacyPolicy: privacyLink = '', eula: eulaLink = '' } = app || {};
   return (
     <div className={styles.disclaimer}>
       <Typography variant={variant} color='textSecondary' data-testid='disclaimer'>
          <span dangerouslySetInnerHTML={{
            __html: t('terms_agreements.connect-app-disclaimer', {
              actionText,
              eulaLink,
              privacyLink,
              escapeInterpolation: false,
            }),
          }} />
       </Typography>
     </div>
   )
}
